@let blok = block();
<button [ngClass]="getOuterClasses()"
        class='tarif-button-custom-styling w-28 h-28 md:w-80 md:h-auto p-4
        md:p-3 shadow-tarif-mobile-button md:shadow-none flex
        flex-col-reverse md:flex-row md:gap-0 justify-between items-center
        disabled:border-grey disabled:text-grey md:hover:bg-grey
        border-2 solid  border-transparent md:border-secondary rounded-xl
        transition duration-200 ease-in'
        (click)="click()"
        [class.is-active]="blok.variant === tariffStore.tariff$()">
    <mat-icon
        [ngClass]="blok.variant==='single' ? '!h-10 !w-auto md:!w-4/12 single' : '!h-10 !w-16 md:!w-4/12 family'"
        [svgIcon]="blok.variant || 'single'"
        aria-hidden="false"
        aria-label="Single Tarif icon" />

    <span class="md:hidden text-[16px] text-center whitespace-nowrap">
 {{ (blok.variant || 'single') === 'single' ? 'Mich' : 'Familie' }}
      </span>
    <span class="hidden md:inline-block w-7/12 text-[24px] text-left whitespace-nowrap">
 {{ (blok.variant || 'single') === 'single' ? 'Mich' : 'Meine Familie' }}
      </span>
</button>
